import { FC, memo, useCallback, useEffect, useState } from 'react'
import { BotChatMessageFeedbackContainer } from './bot-chat-message-feedback-container';
import { BotChatMessageFeedbackIconsContainer } from './bot-chat-message-feedback-icons-container';
import { BotChatMessageFeedbackThumbUpIcon } from './bot-chat-message-feedback-thumb-up-icon';
import { BotChatMessageFeedbackThumbDownIcon } from './bot-chat-message-feedback-thumb-down-icon';
import { BotChatMessageFeedbackFeedbackIcon } from './bot-chat-message-feedback-feedback-icon';
import { ChatMessage } from '../../../../../common/store/chat/types/chat-message';
import { Feedback } from '../../../../../common/store/chat/contants/feedback';
import { useAppDispatch } from '../../../../../common/store';
import { sendFeedbackEmoj } from '../../../../../common/store/chat/thunks/send-feedback-emoj';
import { FeedbackForm } from './feedback-form';
import styled from 'styled-components';
import { sendFeedback } from '../../../../../common/store/chat/thunks/send-feedback';
import { sendMessageLogSubmission } from '../../../../../common/store/chat/thunks/send-message-log';
import getMessageByVurablizeEvent from '../../../../utils/get-message-by-vurablize-event';
import VurbalizeEvents from '../../../../../common/types/dto/chat/vurbalize-events';

interface BotChatMessageFeedbackProps{
  message: ChatMessage;
  index: number;
}

export const BotChatMessageFeedback: FC<BotChatMessageFeedbackProps> = ({
  message, index,
}) => {
  const dispatch = useAppDispatch();
  const handleEmojButtonClick = useCallback((feedback: Feedback) => {
    dispatch(sendFeedbackEmoj({
      turnId: message.turn_id,
      feedback
    }));

    dispatch(sendMessageLogSubmission({ data: {
        message: getMessageByVurablizeEvent(VurbalizeEvents.USER_FEEDBACK, `"${feedback}" message index:${index}`),
        mode: feedback,
        feedback_comment: '',
        turn_id: message.turn_id,
        event_name: VurbalizeEvents.USER_FEEDBACK
      }}))
  }, [dispatch, message, index]);

  const [isFeedbackFormOpened, setIsFeedbackFormOpened] = useState(false);

  const handleFeedbackIconClick = useCallback(() => {
    setIsFeedbackFormOpened((prev) => !prev);
  }, []);

  const handleFeedbackFormSubmit = useCallback((newValue: string) => {
    setIsFeedbackFormOpened(() => false);
    dispatch(sendFeedback({
      turnId: message.turn_id,
      feedback: newValue
    }));
    dispatch(sendMessageLogSubmission({ data: {
      message: getMessageByVurablizeEvent(VurbalizeEvents.FEEDBACK_SUBMITTED),
      feedback_text: newValue,
      event_name: VurbalizeEvents.FEEDBACK_SUBMITTED
    }}))
  }, [dispatch, message]);

  useEffect(() => {
    if (!isFeedbackFormOpened) return;

    dispatch(sendMessageLogSubmission({ data: {
      message: getMessageByVurablizeEvent(VurbalizeEvents.FEEDBACK_FORM),
      event_name: VurbalizeEvents.FEEDBACK_FORM,
    }}))
  }, [isFeedbackFormOpened])

  return (
    <BotChatMessageFeedbackContainer className="likeDislike voa_chat_bot_message_reactions_container">
      <BotChatMessageFeedbackIconsContainer className="voa_chat_bot_message_reactions_icons_container">
        <BotChatMessageFeedbackThumbUpIcon mode={message.mode} onClick={handleEmojButtonClick} />
        <BotChatMessageFeedbackThumbDownIcon mode={message.mode} onClick={handleEmojButtonClick} />
        <BotChatMessageFeedbackFeedbackIcon feedback={message.feedback} onClick={handleFeedbackIconClick} />
      </BotChatMessageFeedbackIconsContainer>
      <FeedbackContainer isOpen={isFeedbackFormOpened} className="feedback_div voa_feedback_container">
        <FeedbackForm
          actualValue={message.feedback}
          handleSubmit={handleFeedbackFormSubmit}
        />
      </FeedbackContainer>
    </BotChatMessageFeedbackContainer>
  )
};

const FeedbackContainer = styled.div<{ isOpen: boolean }>`
  display: ${(props) => props.isOpen ? 'block' : 'none'};
  width: 100%;
`;